"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.magdalena.description': 'Niski, ciepły głos ze spokojną siłą i subtelnością.',
};
